import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useDropzone } from "react-dropzone";
import 'bootstrap/dist/css/bootstrap.min.css'; 
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const FormularioPrograma = () => {
    const apiUrl = process.env.REACT_APP_API_BASE_URL;
    const { id } = useParams();
    const navigate = useNavigate();
    const [formValues, setFormValues] = useState({
        nombre: "",
        descripcion: "",       
        logo: null,
        logoPreview: null,
        usuarioId: "",
        CC: "",
        presupuesto: 0,       
    });
    const [mensajeError, setMensajeError] = useState('');

    useEffect(() => {
        if (id) {
            fetchPrograma(id);
        }
    }, [id]);

    const fetchPrograma = async (programaId) => {
        try {
            const respuesta = await fetch(`${apiUrl}/Programa/${programaId}`);
            const data = await respuesta.json();
            if (respuesta.ok) {
                setFormValues({
                    nombre: data.nombre,
                    descripcion: data.descripcion,
                    logo: null, 
                    logoPreview: data.logoBase64 ? `data:${data.logoMimeType};base64,${data.logoBase64}` : null,
                    usuarioId: data.usuarioId,
                    CC: data.CC,                    
                    presupuesto: 0,    
                });
            } else {
                console.error("Error fetching programa:", data);
                setMensajeError(data.error || 'Error al obtener el programa');
            }
        } catch (error) {
            console.error("Error en la solicitud", error);
            setMensajeError('Error en los datos.');
        }
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormValues({
            ...formValues,
            [name]: value
        });
    }; 

    const handleFileDrop = (acceptedFiles) => {
        setFormValues({
            ...formValues,
            logo: acceptedFiles[0],
            logoPreview: URL.createObjectURL(acceptedFiles[0])
        });
    };

    const { getRootProps, getInputProps } = useDropzone({
        onDrop: handleFileDrop,
        multiple: false,
        accept: '*/*'
    });

    const handleFileChange = (e) => {
        setFormValues({
            ...formValues,
            logo: e.target.files[0],
            logoPreview: URL.createObjectURL(e.target.files[0])
        });
    };

    const registrarPrograma = async (e) => {
        e.preventDefault();
    
        try {
            const { nombre, descripcion, logo, CC, gastos, adelantos, pedidos } = formValues;
    
            const usuarioId = localStorage.getItem('userId');
            const formData = new FormData();
            formData.append('nombre', nombre);
            formData.append('descripcion', descripcion);
            formData.append('CC', CC);
            formData.append('usuarioId', usuarioId);
            if (logo) {
                formData.append('logo', logo);
            }
            formData.append('gastos', JSON.stringify(gastos));
            formData.append('adelantos', JSON.stringify(adelantos));
            formData.append('pedidos', JSON.stringify(pedidos));
    
            const url = id ? `${apiUrl}/Programa/ActualizarPrograma/${id}` : `${apiUrl}/Programa/CrearPrograma`;
    
            const respuesta = await fetch(url, {
                method: id ? 'PUT' : 'POST',
                body: formData,
                headers: {
                    'apiKey': localStorage.getItem("apiKey")
                },
            });
    
            const data = await respuesta.json();
    
            if (respuesta.ok) {
                toast.success(`¡El programa: ${nombre} se ha ${id ? 'actualizado' : 'registrado'} con éxito!`, {
                    position: "bottom-center",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                });
                navigate("/DashboardSoporte");
                setMensajeError('');
                setFormValues({
                    nombre: '',
                    descripcion: '',
                    logo: null,
                    logoPreview: null,
                    CC: '',
                    gastos: [],
                    adelantos: [],
                    pedidos: [],
                });
            } else {
                console.error("Error al registrar la solicitud", data);
                setMensajeError(data.error || `Error al ${id ? 'actualizar' : 'registrar'} la solicitud`);
            }
        } catch (error) {
            console.error("Error en la solicitud", error);
            setMensajeError('Error en los datos.');
        }
    };
    
    return (
        <div className="container d-flex justify-content-center align-items-center" style={{ marginTop:"6rem"}}>
            <div className="w-100" style={{ maxWidth: "450px" }}>
                <h2 className="text-center mb-3" style={{ fontSize: "20px" }}>{id ? 'Editar Programa' : 'Solicitud de Programa'}</h2>
                <form onSubmit={registrarPrograma} className="border p-3 rounded bg-white shadow-sm" style={{ fontSize: "14px" }}>
                    <div className="form-group mb-2">
                        <label htmlFor="inputProgramaNombre">Nombre</label>
                        <input
                            type="text"
                            className="form-control"
                            id="inputProgramaNombre"
                            name="nombre"
                            value={formValues.nombre}
                            onChange={handleChange}
                            placeholder="Nombre del programa"
                            required
                        />
                    </div>
                    <div className="form-group mb-2">
                        <label htmlFor="inputProgramaDescripcion">Descripción</label>
                        <input
                            type="text"
                            className="form-control"
                            id="inputProgramaDescripcion"
                            name="descripcion"
                            value={formValues.descripcion}
                            onChange={handleChange}
                            placeholder="Descripción"
                            required
                        />
                    </div>
                    <div className="form-group mb-2">
                        <label htmlFor="inputProgramaCentroDeCosto">Centro de costo</label>
                        <input
                            type="text"
                            className="form-control"
                            id="inputProgramaCentroDeCosto"
                            name="CC"
                            value={formValues.CC} 
                            onChange={handleChange}
                            placeholder="Centro de costo"
                            required
                        />
                    </div>
                    <div className="form-group mb-2">
                        <label htmlFor="inputProgramaLogo">Logo</label>
                        <div {...getRootProps({ className: 'dropzone' })} className="border p-3 text-center">
                            <input {...getInputProps()} id="inputProgramaLogo" onChange={handleFileChange} />
                            {formValues.logo ? (
                                <p>{formValues.logo.name}</p>
                            ) : formValues.logoPreview ? (
                                <img src={formValues.logoPreview} alt="Logo Preview" style={{ maxWidth: '100px', maxHeight: '100px' }} />
                            ) : (
                                <p>Arrastra y suelta el archivo aquí, o haz clic para seleccionarlo</p>
                            )}
                        </div>
                    </div>

                    <div className="d-flex justify-content-end">
                        <button className="btn btnColorPrincipal form-control btn-primary" type="submit">Enviar solicitud</button>
                    </div>
                </form>

                {mensajeError && <div className="alert alert-danger mt-2" style={{ fontSize: "14px" }}>{mensajeError}</div>}
            </div>
        </div>
    );
};

export default FormularioPrograma;